var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "figcaption",
    {
      staticClass: "caption",
      style: { color: _vm.person.colors["text-primary"] },
    },
    [
      _c("line-cover", { staticClass: "decoration" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "summary" },
        [
          _c("p", {
            staticClass: "text",
            style: { color: _vm.person.colors["text-primary"] },
            domProps: { innerHTML: _vm._s(_vm.person.description) },
          }),
          _vm._v(" "),
          _c("caption-tags", {
            attrs: {
              tags: _vm.person.tags,
              color: _vm.person.colors["text-secondary"],
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }